import React from "react";
import "./Menu.css"
import {FormattedMessage} from 'react-intl';
import actions from "../store/actions"
import {connect} from "react-redux";
 class Menu extends React.Component {
    constructor(props, context) {
        super(props, context)  
    }
    state={
        show:false,
        showWXQR:false,
        showWBQR:false
    }
   yqClick(){
       this.setState({
        show:!this.state.show
       })
   }
   mouseEnter(type){
       console.log(type);
       if(type==='wx'){
           this.setState({
               showWBQR:false,
               showWXQR:true
           });
       }
       if(type==="wb"){
        this.setState({
            showWBQR:true,
            showWXQR:false
        });
       }
   }
   mouseLeave(type){
    if(type==='wx'){
        this.setState({
            showWBQR:false,
            showWXQR:false
        });
    }
    if(type==="wb"){
     this.setState({
         showWBQR:false,
         showWXQR:false
     });
    }
   }
    render() {
        let year=new Date().getFullYear();
       let {showWBQR,showWXQR}=this.state;
        return <div className="footer">
            <div className="footerBox">
            <div className="foot-nav">
                <ul className="footer-nav">
                    <li>
                    <a target="_blank" href="https://shop.lenovo.com.cn/investor/html/legal.html"><FormattedMessage id="intl-Menu-Terms"/></a>
                    </li>
                    <li>
                    <a target="_blank" href="https://shop.lenovo.com.cn/investor/html/privacy.html?_ga=2.4843901
3.293137868.1557482374-1657134529.1556434410"><FormattedMessage id="intl-Menu-Privacy"/></a>
                    </li>
                    <li style={{paddingRight:'0px'}}>
                    <a onClick={this.yqClick.bind(this)} className="yqlj09"><FormattedMessage id="intl-Menu-Directions"/></a>
                    <ul className="footer-hover">
                        <li><a href="https://www.amap.com/place/B0FFKP7XNP" target="_blank" ><FormattedMessage id="intl-area-bj"/></a></li>
                        <li>
                        <a href="https://www.amap.com/place/B0GKUSH8LM" target="_blank" ><FormattedMessage id="intl-area-sh"/></a>
                        </li>
                        <li>
                        <a href="https://www.amap.com/place/B0H3SHJ0OR" target="_blank" ><FormattedMessage id="intl-area-sz"/></a>
                        </li>
                        <li style={{paddingTop:'0px'}}>
                        <a href="https://www.amap.com/place/B0J0KU4PT8" target="_blank" ><FormattedMessage id="intl-area-tj"/></a>
                        </li>
                    </ul>
                    </li>
                    <li style={{width:'0px',padding:'0px'}}>&nbsp;</li>
                    <li>
                    <a onClick={this.yqClick.bind(this)} className="yqlj09"><FormattedMessage id="intl-Menu-Links"/></a>
                    <ul className="footer-hover">
                        <li><a href="https://www.lenovo.com.cn/" target="_blank" ><FormattedMessage id="intl-Menu-LenovoGroup"/></a></li>
                        <li>
                        <a href="https://shop.lenovo.com.cn/" target="_blank" ><FormattedMessage id="intl-Menu-LenovoStore"/></a>
                        </li>
                    </ul>
                    </li>
                </ul>
                <ol className="footer-address">
                    <li><FormattedMessage id="intl-Menu-Contact"/>futurecenter@lenovo.com </li>
                    <li>
                        <FormattedMessage id="intl-Menu-Address"/> 
                    </li>
                    <li style={{paddingLeft: this.props.local=='en'?'66px':'70px'}}><FormattedMessage id="intl-Menu-shAddress"/></li>
                    <li style={{paddingLeft: this.props.local=='en'?'66px':'70px'}}><FormattedMessage id="intl-Menu-szAddress"/></li>
                    <li style={{paddingLeft: this.props.local=='en'?'66px':'70px'}}><FormattedMessage id="intl-Menu-tjAddress"/></li>

                </ol>        
            </div>
            <ul className="fonnterCode">
                <li>
                <p>
                    <img src="images/weixin.png"  alt=""/>
                    <span><FormattedMessage id="intl-Menu-WeChat"/></span>
                    </p>
                    <p className="fonnterImg">
                    <img src="images/weixincode.png" width="120" height="120" alt="微博二维码图片" />
                    </p>
                </li>
                <li>
                    <p>
                    <img src="images/weibo.png"  alt=""/>
                    <span><FormattedMessage id="intl-Menu-Weibo"/></span>
                    </p>
                    <p className="fonnterImg">
                    <img src="images/weibo_code.png" width="120" height="120" alt="微博二维码图片" />
                    </p>
                </li>
                
            </ul>
          
            </div>
            <p className="beian"> 版权所有:1998-{year} 联想集团 | 京ICP备20022351号</p>
        </div>
    }
}
export default connect(state => ({...state.Language}), actions.Language)(Menu)




// WEBPACK FOOTER //
// ./src/component/Menu.js